export default "__VITE_ASSET___e4SlPrA__"